










import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

/**
 * 過去、ユーザーが入力したメールアドレスを自動で小文字に変換して会員登録を行っていた時期がある。
 * このときに会員登録したユーザーは、自身は大文字で登録したつもりだが、大文字でログインを試みるとログインできないことになる。
 * 後に自動での小文字化を廃止することにしたが、過去に自動で小文字化されたユーザーが別途大文字でアカウントを再作成することをなるべく避けるために
 * 入力したメールアドレスに大文字が含まれている場合、小文字でのログインを試してくださいというメッセージを出している。
 * @see https://github.com/Everforth/growthpalette-front/issues/6807
 * @see https://github.com/Everforth/growthpalette-front/issues/8848
 */
@Component
export default class IncorrectAuthenticationDataContainsUppercaseError extends Vue {
  @Prop({ default: 'p' })
  readonly tag: string
}
